<template>
  <div class="payment-form-wrapper">
    <template v-if="product && product.require_payment">
      <coupon :currentCoupon="couponCode" @couponSubmit="setCoupon($event)"></coupon>
      <h3 class="payment">Payment Details:</h3>

      <div class="radio-wrapper">
        <div class="radio">
          <input
            id="radio-2"
            name="payment-type"
            type="radio"
            @click="setPaymentType('basc_payment')"
            checked
          />
          <label for="radio-2" class="radio-label">Pay By Direct Debit</label>
          <div class="bacs-description" v-if="paymentType === 'basc_payment'">
            Bank details will collected after you click submit
          </div>
        </div>

        <div class="radio">
          <input
            id="radio-1"
            name="payment-type"
            type="radio"
            @click="setPaymentType('credit_card')"
          />
          <label for="radio-1" class="radio-label"
            >Pay By Credit or Debit Card</label
          >
        </div>
      </div>

      <div id="card" v-show="paymentType === 'credit_card'">
        <div class="cell example payment" id="payment">
          <div class="row">
            <div class="field">
              <div
                id="payment-card-number"
                ref="card_number"
                class="input empty"
              ></div>
              <label
                for="payment-card-number"
                data-tid="elements_payment.form.card_number_label"
                >Card number</label
              >
              <div class="baseline"></div>
            </div>
          </div>
          <div class="row">
            <div class="field half-width">
              <div
                id="payment-card-expiry"
                ref="card_expiry"
                class="input empty"
              ></div>
              <label
                for="payment-card-expiry"
                data-tid="elements_payment.form.card_expiry_label"
                >Expiration</label
              >
              <div class="baseline"></div>
            </div>
            <div class="field half-width">
              <div
                id="payment-card-cvc"
                ref="card_cvc"
                class="input empty"
              ></div>
              <label
                for="payment-card-cvc"
                data-tid="elements_payment.form.card_cvc_label"
                >CVC</label
              >
              <div class="baseline"></div>
            </div>
          </div>
        </div>
      </div>

      <div id="debit" v-show="paymentType === 'basc_payment'"></div>
    </template>
    <h3>Agreement:</h3>
    <div class="disclaimers">
      <p>
        Any personal information you provide us will be processed in accordance with the UK General
        Data Protection Regulation (UK GDPR) and Data Protection Act (DPA) 2018. We thus have a
        legal obligation to protect any data collected from you and will use the information to process
        your requests, personalise and provide our services. It will allow us, to focus on your business
        development needs to develop more bespoke ways of assisting your professional growth. It may
        also be used to support our market research activities. We will not use it for marketing purposes
        unless you have specifically consented.
      </p>
      <div class="form-control disclaimer">
        <input
          type="checkbox"
          id="checkbox-1"
          class="checkbox"
          name="opt-out"
          v-model="opt_out"
          value="1"
        />
        <label class="box" for="checkbox-1"></label>
        <label class="text" for="checkbox-1"
          ><p>
            Please tick this box to receive Model Office governance, risk and
            compliance information to aid strengthening your compliance scores
          </p>
        </label>
      </div>

      <Field
          vid="checkbox_2"
          rules="required"
          name="Privacy Policy"
          v-slot="{ field, errors }"
      >
        <div class="form-control disclaimer req-check-target validate">
          <input
              type="checkbox"
              id="checkbox-2"
              class="checkbox req-check"
              name="checkbox_2"
              value="1"
              v-model="checkbox_2"
          />
          <label class="box" for="checkbox-2"></label>
          <label for="checkbox-2" class="text"
          ><p>
            Please tick this box if you have read and accepted our
            <a href="/terms-and-conditions">Terms and Conditions</a> and
            <a href="/privacy-policy">Privacy Policy</a>
          </p>
          </label>
        </div>
        <ErrorMessage class="error_message" as="div" name="checkbox_2" v-slot="{ message }">
          {{ message }}
        </ErrorMessage>
      </Field>

      <div class="error-message" v-if="errors">
        <div class="error-text" v-for="error in errors">
          <span v-for="i in error"> {{ i }}</span>
        </div>
      </div>
    </div>
    <button
      type="submit"
      class="btn btn-primary submit"
      :disabled="!checkbox_2"
      v-if="mode === 'create'"
    >
      <span v-if="isLoading">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
      <span v-else>
        Submit
      </span>
    </button>

    <button
      type="submit"
      class="btn btn-primary submit"
      :disabled="!checkbox_2"
      v-if="mode === 'upgrade'"
      @click="upgrade"
    >
      <span v-if="isLoading">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
      <span v-else>
        Submit
      </span>
    </button>
    <input
      type="checkbox"
      name="contact_me_by_jbc_only"
      value="1"
      style="display: none !important"
      tabindex="-1"
      autocomplete="off"
    />
    <input
      id="payment_type"
      type="hidden"
      name="payment_type"
      value="credit_card"
    />
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";
import Coupon from "./Coupon";

export default {
  name: "PaymentForm",
  components: { coupon: Coupon },
  props: ["product", "addonProducts", "user", "mode", "couponCode", "networkKey"],
  data() {
    return {
      stripe: {},
      cardNumber: {},
      cardExpiry: {},
      cardCvc: {},
      paymentMethod: null,
      elements: null,
      paymentType: "basc_payment",
      checkbox_2: false,
      opt_out: false,
      coupon: null,
      errors: null,
      isLoading: false,
      setupIntent: null
    };
  },
  methods: {
    initializePaymentForm() {
      loadStripe(process.env.MIX_STRIPE_KEY).then((stripe) => {
        this.stripe = stripe;
        this.elements = this.stripe.elements();

        var elementStyles = {
          base: {
            color: "#32325D",
            fontWeight: 500,
            fontFamily: "museo-sans-rounded, Source Code Pro, Menlo, monospace",
            fontSize: "16px",
            fontSmoothing: "antialiased",
            "::placeholder": {
              color: "#CFD7DF",
            },
            ":-webkit-autofill": {
              color: "#e39f48",
            },
          },
          invalid: {
            color: "#E25950",

            "::placeholder": {
              color: "#FFCCA5",
            },
          },
        };

        var elementClasses = {
          focus: "focused",
          empty: "empty",
          invalid: "invalid",
        };

        this.cardNumber = this.elements.create("cardNumber", {
          style: elementStyles,
          classes: elementClasses,
        });
        this.cardNumber.mount("#payment-card-number");

        this.cardExpiry = this.elements.create("cardExpiry", {
          style: elementStyles,
          classes: elementClasses,
        });
        this.cardExpiry.mount("#payment-card-expiry");

        this.cardCvc = this.elements.create("cardCvc", {
          style: elementStyles,
          classes: elementClasses,
        });
        this.cardCvc.mount("#payment-card-cvc");

        this.createSetupIntent();
      });
    },
    createSetupIntent(data, action) {
      axios.post("/create-setup-intent", data)
          .then((response) => {
            this.setupIntent = response.data.data.client_secret
          })
          .catch((error) => {
            console.error("Error creating PaymentIntent:", error);
            this.isLoading = false;
            this.errors = error.response ? error.response.data.errors : ["An error occurred while processing your payment."];
          });
    },
    upgrade() {
      this.isLoading = true;
      let upgradeData = {
        coupon: this.coupon ?? null,
        //level: this.type,
        payment_method: null,
        payment_type: this.paymentType,
        opt_out: this.opt_out,
        checkbox_2: this.checkbox_2,
        user_id: this.user.id,
        product: this.product.id,
        addon_products: this.addonProducts,
      };
      if (this.paymentType === "credit_card") {
        if (this.checkCard()) {
          this.getPaymentMethod().then(() => {
            upgradeData.payment_method = this.paymentMethod;
            this.runUpgrade(upgradeData);
          });
        }
      } else if (this.paymentType === "basc_payment") {
        this.runUpgrade(upgradeData);
      }
    },
    runUpgrade(upgradeData) {
      axios
        .post("/upgrade", upgradeData)
        .then((res) => {
          if (this.paymentType === "basc_payment") {
            this.stripe
              .redirectToCheckout({
                sessionId: res.data.id,
              })
              .then(function (res) {
                console.log("res", res);
              });
          } else {
            console.log("result", res);
            const documentsSlugs = ['monitor_ai','monitor_ai_pro', 'additional_monitor_ai', 'additional_monitor_ai_pro'];
            const ioSlugs = ['additional_io_single_reviews', 'additional_io_bulk_reviews'];
            const additionalUserSlugs = ['additional_user_classic', 'additional_user_classic_pro'];

            if (documentsSlugs.includes(this.product.slug)) {
              window.location.href = "/documents";
            } else if (ioSlugs.includes(this.product.slug)) {
              window.location.href = "/io/client-file-reviews";
            }else if (additionalUserSlugs.includes(this.product.slug)) {
              window.location.href = "/account/invitations/create";
            } else {
              window.location.href = "/dashboard";
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.isLoading = false;
        });
    },
    setCoupon(coupon) {
      this.coupon = coupon.id;
      this.$emit('couponApplied', coupon);
    },
    processRegistration(user) {
      let registrationData = {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        password: user.password,
        password_confirmation: user.password_confirmation,
        company_name: user.company_name,
        coupon: this.coupon ?? null,
        network_key: this.networkKey || null,
        //level: this.type,
        payment_method: this.paymentMethod,
        payment_type: this.paymentType,
        opt_out: this.opt_out,
        checkbox_2: this.checkbox_2,
        product: this.product.id,
        addon_products: this.addonProducts
      };

      console.log(this.paymentMethod);

      axios
        .post(`/auth/register`, registrationData)
        .then((res) => {
          if (this.paymentType === "basc_payment") {
            this.stripe
              .redirectToCheckout({
                sessionId: res.data.id,
              })
              .then(function (result) {
                console.log("result", result);
              });
          } else {
            window.location.href = (res.data && res.data.redirect) ? res.data.redirect : "/dashboard";
          }
        })
        .catch((error) => {
          if (error.response) {
            this.errors = error.response.data.errors;
            let newArray = Object.values(error.response.data.errors).flat(3);
            console.log("newArray", newArray);
            console.log(error);
            this.isLoading = false;
          }
        });
    },
    checkCard() {
      if (
        !this.$refs.card_number.classList.contains("StripeElement--complete")
      ) {
        this.$refs.card_number.classList.add("invalid");
      }
      if (
        !this.$refs.card_expiry.classList.contains("StripeElement--complete")
      ) {
        this.$refs.card_expiry.classList.add("invalid");
      }
      if (!this.$refs.card_cvc.classList.contains("StripeElement--complete")) {
        this.$refs.card_cvc.classList.add("invalid");
      } else {
        return true;
      }

      return false;
    },
    getPaymentMethod() {
      return this.stripe.confirmCardSetup(this.setupIntent, {
        payment_method: {
          card: this.cardNumber,
          billing_details: {
            name: this.user.first_name + " " + this.user.last_name,
          },
        }
      }).then((result) => {
        if (result.error) {
          console.error("Payment failed:", result.error);
          this.isLoading = false;
          this.errors = [result.error.message];
        } else {

          this.paymentMethod = result.setupIntent.payment_method;
          console.log(this.paymentMethod);
        }
      });
    },
    pay(user) {
      this.isLoading = true;
      if (this.paymentType === "credit_card") {
        if (this.checkCard()) {
          this.getPaymentMethod().then(() => {
            this.processRegistration(user);
          });
        }
      } else {
        this.processRegistration(user);
      }
    },
    setPaymentType(value) {
      this.paymentType = value;
    },
  },
  created() {
    if (this.product.require_payment) {
      this.initializePaymentForm();
    } else {
      this.paymentType = null;
    }
  },
};
</script>

<style scoped >
.error-message {
  background-color: #fce4e4;
  border: 1px solid #fcc2c3;
  padding: 20px 30px;
}

.error-text {
  color: #cc0033;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  font-weight: bold;
  line-height: 20px;
  text-shadow: 1px 1px rgba(250, 250, 250, 0.3);
}
</style>
